
import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 

import TextField from '@mui/material/TextField';





import SearchIcon from '@mui/icons-material/Search';
import ReactToPrint from 'react-to-print';





import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const headCells = [

	
  { id: 'cu_name', numeric: false, label: 'Name' },
  { id: 'cu_emailid', numeric: false, label: 'Email Id' },
  { id: 'cu_phoneno', numeric: false, label: 'Phone No.' },  
  { id: 'cu_billingaddress', numeric: false, label: 'Billing Address' },  
  
    
  { id: 'cu_isactive', numeric: false,  label: 'Status' },
 
 ]

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});




export default class Admincustomer extends Component {
	
    constructor(props) {
    super(props);
   
     this.state = {
		 
		 
		 ExportData:[],id:'',cu_name:'',cu_billingaddress:'',
	 
	  search:'',isactive:'',searchactive:'',
		       
		 redirect: false,editredirect: false,no_id:'',no_date:'',fb_staff:0,no_remiderdate:'',type:'',exportdata:[],
     CustomerData:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],rolelabel:'Select Staff',staff:'',staffarray:[],subscribeData:[],subid:'',
	 
	  order:'desc' ,orderBy:'',
	          
      }
	  this.updateDonenewParent = this.updateDonenewParent;
	}
	  



	


handleChangePage = (event, newPage) => {  

  
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  	 myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 

  this.setState({[nam]: val});
  
}

   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };  

componentWillMount  () {
	

	
	document.title = "AthaYog Living - Feedback";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }

	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  
}








blockcustomer(cid){
	 
	 let r = window.confirm("Do you really want to Block?");
		 if(r === true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','Inactive')
					 formData.append('cu_id',cid)
					 formData.append('cu_isactive',1)
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					 
					  axios.post(Serverurl+"ajaxcustomer.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 } 
 

unblockcustomer(cid){
	 
	 let r = window.confirm("Do you really want to Unblock?");
		 if(r === true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','Inactive')
					 formData.append('cu_id',cid)
					 formData.append('cu_isactive',0)
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					 
					  axios.post(Serverurl+"ajaxcustomer.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 } 




apicall(page,rowsPerPage){
	
  axios.get(Serverurl+'ajaxcustomer.php?action=getall&cu_name='+this.state.cu_name+'&cu_isactive='+this.state.isactive+'&StartIndex='+page+'&PageSize='+rowsPerPage)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  CustomerData:resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
		this.apiExportcall();
			
	 
     }
	 else{
		   this.setState({CustomerData:[],totaldata:0});
	 }
 
    });
}

apiExportcall(){
	
 axios.get(Serverurl+'ajaxcustomer.php?action=getall')

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  ExportData:resp.data,  
			   
			   

		    });
		
			
		
	 
     }
	 else{
		   this.setState({ExportData:[]});
	 }
 
    });
}










 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
 
 FeedBackDelete(fbid){ 
	
    let r = window.confirm("Do you really want to Delete?");
    if(r === true){ //sign Out logic
		var formData = new FormData();
		formData.append('action','delete')	 
		formData.append('fb_id',fbid)
			   
		formData.append('userid',localStorage.getItem("AYLuserid"))	
		axios.post(Serverurl+"ajaxfeedback.php", formData, {
		}).then(res => {    
				this.apicall(this.state.page,this.state.rowsPerPage);
	 		});
    }
}
	  



handleClickSearch=()=>{   
   
  this.apicall(this.state.page,this.state.rowsPerPage); 
	
} 

render() {
	
	
	if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return(
 
 
 <React.Fragment>
 
  <div className="mainheading"><h1>Customer Report</h1></div>

<div className="clear"></div>

	
	

 <div className="searchmaster">
 <ul>
  
 <li><p>Name</p>
 <p><TextField name="cu_name" 
	   onChange={this.myChangeHandler} 
	   fullWidth 		 	 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   value={this.state.cu_name}
                          /></p>
 
 </li>
				
					<li><p>&nbsp;</p><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> &nbsp;
		<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="Cusomerreport"
							filename="Customer Repor"
							sheet="Customer Report"
							buttonText="EXPORT"/>
							
			</p>		
		</li>		
		<li><p>
							
<ReactToPrint
						trigger={() => <p id="print-barcode" className="frmSecondarybtn"> PRINT </p>}
						content={() => this.componentRef}/>
				</p>		
		</li>
		
		
		</ul>
		
</div>	

		<div  ref={el => (this.componentRef = el)}  >	
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.CustomerData.length}
            />
                      <TableBody>
                     {stableSort(this.state.CustomerData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >

<TableCell style={{"width":"20px"}}>{item.cu_name}</TableCell>
<TableCell style={{"width":"20px"}}>{item.cu_emailid}</TableCell>
<TableCell style={{"width":"20px"}}>{item.cu_phoneno}</TableCell>
<TableCell style={{"width":"20px"}}>{item.cu_billingaddress}</TableCell>
	
<TableCell style={{"width":"20px"}}>

 {item.cu_isactive ==="0" &&(
<p>Active</p>

 )}
	
	
	 {item.cu_isactive ==="1" &&(

<p>In Active</p>

	 )}
 </TableCell>

	

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50,100,150,200,250,300]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}    
      /> 
  </Paper>
    

</div>




<div style={{"display":"none"}}>
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="Cusomerreport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.ExportData.length}
            />
                      <TableBody>
                     {stableSort(this.state.ExportData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.cu_name}</TableCell>
<TableCell>{item.cu_emailid}</TableCell>
<TableCell>{item.cu_phoneno}</TableCell>

<TableCell>{item.cu_billingaddress}</TableCell>
<TableCell>{item.cu_isactive ==="0" &&(
<p>Active</p>

 )}
	
	 {item.cu_isactive ==="1" &&(

<p>In Active</p>

	 )}

</TableCell>


 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
 
  </Paper>
 
</div>


 </React.Fragment>
 



);


		}
	
}

